import React, { useState, useEffect, useRef } from "react";
import ChequeImageViewer from "./cheque-image-viewer";
import SecurePDFViewer from "./secure-pdf-viewer";
import { Row, Col } from "react-flexbox-grid";
import { Button } from "react-md";
import { SelectField } from "react-md";
import {
  TextField,
  InputAdornment,
  MenuItem,
  Menu,
  IconButton,
  InputLabel,
  FormControl,
  Box,
  Checkbox,
  FormControlLabel,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import DoneAnimation from "assets/icons/done-animation.gif";

const BankAccountSuccessScreen = ({
  heading,
  subHeading,
  handleCloseModal,
  onClickDone,
}) => {
  return (
    <div
      style={{ width: "600px", left: "20%" }}
      className="custom-modal-content scrollable-modal-full-height"
    >
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
        }}
      >
        <div
          style={{
            width: "100%",
            fontSize: "24px",
            fontWeight: 700,
            fontFamily: "Montserrat",
            textAlign: "center",
          }}
        >
          {""}
        </div>

        <IconButton onClick={handleCloseModal}>
          <CloseIcon fontSize="large" />
        </IconButton>
      </div>

      <div style={{ display: "flex", flexDirection: "row" }}>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            padding: "32px",
            width: "100%",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <img width={320} height={320} src={DoneAnimation}></img>

          <div
            style={{
              fontSize: "24px",
              fontWeight: 700,
              fontFamily: "Montserrat",
              textAlign: "center",
            }}
          >
            {heading ?? ""}
          </div>
          {Boolean(subHeading) && (
            <>
              <div style={{ height: "16px" }}></div>
              <div style={{ textAlign: "center" }}>{subHeading ?? ""}</div>
            </>
          )}

          <div style={{ height: "32px" }}></div>
          <Button
            fullWidth
            variant="contained"
            onClick={(e) => {
              if (onClickDone) {
                onClickDone();
              }
            }}
            className="full-width-button"
            style={{
              backgroundColor: "#f57c00",
              color: "#fff",
              marginTop: "20px",
            }}
          >
            {"Done"}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default BankAccountSuccessScreen;
